module.exports = __webpack_public_path__ + "static/img/guava.b8b652c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/index/guava.jpg
// module id = 5PUB
// module chunks = 1